module.exports = __webpack_public_path__ + "static/media/sbom-slide-2.bb3e8c33.jpg";